export default "__VITE_ASSET__dcc1b122__"